var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { inject } from "tsyringe";
import { Availability } from "../Availability";
import { ExtraFeeTypes, } from "../Menu";
import { IdMap } from "../../collections";
import { ModifierItemTypeAvailabilityService } from "./ModifierItemTypeAvailabilityService";
import { ModifierTypeAvailabilityService } from "./ModifierTypeAvailabilityService";
import { FulfillmentInstructions, FulfillmentInstructionsToken, } from "../FulfillmentInstructions";
import { isAddedAtCompatible } from "../PackagingFeeCompatibility";
let ModifierItemInstanceAvailabilityService = class ModifierItemInstanceAvailabilityService {
    constructor(modifierTypeAvailabilityService, modifierItemTypeAvailabilityService, extraFeeTypes, fulfillmentInstructions) {
        this.modifierTypeAvailabilityService = modifierTypeAvailabilityService;
        this.modifierItemTypeAvailabilityService = modifierItemTypeAvailabilityService;
        this.extraFeeTypes = extraFeeTypes;
        this.fulfillmentInstructions = fulfillmentInstructions;
        makeImmutable(this);
    }
    modifierTypeAvailability(modifierType, parameterScope) {
        const modifierTypeAvailability = this.modifierTypeAvailabilityService.availability(modifierType, parameterScope);
        return Availability.dependent("ModifierType", modifierType.id.value, modifierTypeAvailability);
    }
    packagingFeeAvailability(modifierItemInstance) {
        const feeId = modifierItemInstance.modifierItemPackagingFeeId;
        if (feeId === null) {
            return Availability.available();
        }
        const fee = this.extraFeeTypes.find(feeId);
        if (fee === null) {
            return Availability.available();
        }
        const fulfillmentMethod = this.fulfillmentInstructions.fulfillmentMethod;
        return Availability.boolean({
            PackagingFee: !isAddedAtCompatible(fee.addedAt, fulfillmentMethod),
        });
    }
    unitAvailability(modifierItemInstance, parameterScope) {
        return Availability.composite([
            this.modifierTypeAvailability(modifierItemInstance.modifierType, parameterScope),
            this.modifierItemTypeAvailabilityService.availability(modifierItemInstance.modifierItemType, parameterScope),
            this.packagingFeeAvailability(modifierItemInstance),
        ]);
    }
};
ModifierItemInstanceAvailabilityService = __decorate([
    perRestaurant(),
    __param(2, inject(ExtraFeeTypes)),
    __param(3, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof ModifierTypeAvailabilityService !== "undefined" && ModifierTypeAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof ModifierItemTypeAvailabilityService !== "undefined" && ModifierItemTypeAvailabilityService) === "function" ? _b : Object, typeof (_c = typeof IdMap !== "undefined" && IdMap) === "function" ? _c : Object, typeof (_d = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _d : Object])
], ModifierItemInstanceAvailabilityService);
export { ModifierItemInstanceAvailabilityService };
